export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderSIP@3x.png";